import { render, staticRenderFns } from "./RolesArea.vue?vue&type=template&id=48b37e08"
import script from "./RolesArea.vue?vue&type=script&lang=js"
export * from "./RolesArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports